import { apiClient } from '../lib/apiClient';
import type { Currency } from '../config/currencies';

/** General preferences of the signed-in user, used across the app (GET/PATCH /api/v1/me/preferences). */
export interface UserPreferences {
  currency: Currency;
  /** Measurement cards of the dashboard (parameter ids, in order); null = the default set. */
  dashboardParameters: string[] | null;
}

export const USER_PREFERENCES_QUERY_KEY = ['me', 'preferences'] as const;

export async function fetchUserPreferences(): Promise<UserPreferences> {
  const res = await apiClient.get<{ data: UserPreferences }>('/api/v1/me/preferences');
  return res.data;
}

export async function updateUserPreferences(patch: Partial<UserPreferences>): Promise<UserPreferences> {
  const res = await apiClient.patch<{ data: UserPreferences }>('/api/v1/me/preferences', patch);
  return res.data;
}
